import React from 'react';
import styled from 'styled-components';

const ServicesSection = styled.section`
  padding: ${({ theme }) => `${theme.spacing['2xl']} 0`};
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  
  h2 {
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.125rem;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background: white;
  padding: 3rem 2rem;
  border-radius: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: ${({ theme }) => theme.transitions.default};
  border: 2px solid transparent;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

const ServiceIcon = styled.div`
  width: 100px;
  height: 100px;
  background: ${({ theme }) => theme.colors.black};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  font-size: 2.5rem;
  color: white;
  transition: ${({ theme }) => theme.transitions.default};
  
  ${ServiceCard}:hover & {
    background: ${({ theme }) => theme.colors.accent};
    transform: scale(1.1);
  }
`;

const ServiceTitle = styled.h3`
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 1.25rem;
`;

const ServiceDescription = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1.6;
`;

const ServiceFeatures = styled.ul`
  list-style: none;
  margin-top: 1.5rem;
  
  li {
    padding: 0.5rem 0;
    color: ${({ theme }) => theme.colors.gray};
    position: relative;
    padding-left: 1.5rem;
    
    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: ${({ theme }) => theme.colors.accent};
      font-weight: bold;
    }
  }
`;

const services = [
  {
    icon: '🖤',
    title: 'Modern Dance',
    description: 'Taniec współczesny, gdzie każdy ruch opowiada historię. Grupa początkująca i średnio zaawansowana.',
    features: [
      'Grupa początkująca (Oliwia)',
      'Grupa średnio zaawansowana (Nastya)',
      'Ekspresja przez ruch',
      'Technika współczesna'
    ]
  },
  {
    icon: '👠',
    title: 'High Heels',
    description: 'Taniec na obcasach budujący pewność siebie i kobiecość. Grupa początkująca.',
    features: [
      'Grupa początkująca (Nastya)',
      'Budowanie pewności siebie',
      'Kobieca ekspresja',
      'Elegancja i moc'
    ]
  },
  {
    icon: '🤸‍♂️',
    title: 'Akrobatyka i Wzmacnianie',
    description: 'Zajęcia rozwijające siłę, stabilizację i gibkość. Podstawy akrobatyki dla bezpiecznego tańca.',
    features: [
      'Trening siłowy (Łukasz)',
      'Rozwój gibkości',
      'Stabilizacja ciała',
      'Podstawy akrobatyki'
    ]
  },
  {
    icon: '💍',
    title: 'Pierwszy Taniec',
    description: 'Przygotowanie do najważniejszego tańca w waszym życiu. Indywidualne podejście do każdej pary.',
    features: [
      'Choreografia na miarę',
      'Indywidualne lekcje',
      'Dopasowanie do osobowości',
      'Przygotowanie do ślubu'
    ]
  },
  {
    icon: '🧒',
    title: 'Zajęcia dla Dzieci',
    description: 'Taneczna zabawa dla najmłodszych rozwijająca koordynację, rytm i kreatywność.',
    features: [
      'Modern dla dzieci (Oliwia)',
      'Rozwój koordynacji',
      'Zabawa przez ruch',
      'Przyjazna atmosfera'
    ]
  },
  {
    icon: '👨‍👩‍👧‍👦',
    title: 'Zajęcia dla Dorosłych',
    description: 'Taniec to pasja bez granic wiekowych. Zajęcia dostosowane do potrzeb dorosłych początkujących.',
    features: [
      'Modern dla dorosłych (Oliwia)',
      'Komfortowa atmosfera',
      'Początkujący mile widziani',
      'Rozwój osobisty'
    ]
  }
];

const Services = () => {
  return (
    <ServicesSection id="services" className="section">
      <div className="container">
        <SectionHeader>
          <h2>Nasze Zajęcia Taneczne</h2>
          <p>
            Profesjonalne zajęcia taneczne dla dzieci, młodzieży i dorosłych w Zielonej Górze.
            Modern, High Heels, Akrobatyka i Pierwszy Taniec - znajdź swój styl!
          </p>
        </SectionHeader>
        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard key={index}>
              <ServiceIcon>{service.icon}</ServiceIcon>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceDescription>{service.description}</ServiceDescription>
              <ServiceFeatures>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ServiceFeatures>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </div>
    </ServicesSection>
  );
};

export default Services;
